import { render, staticRenderFns } from "./templete2.vue?vue&type=template&id=8a385e12&scoped=true"
import script from "./templete2.vue?vue&type=script&lang=js"
export * from "./templete2.vue?vue&type=script&lang=js"
import style0 from "./templete2.vue?vue&type=style&index=0&id=8a385e12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a385e12",
  null
  
)

export default component.exports